module.exports = __webpack_public_path__ + "media/images/illustrations/mover_with_twenty_foot_truck-08ca409984bd0232ea8e6e13851a958d.svg";